export const createClientCodeFilter = (clientCode: string) => ({
  groupKey: 'CLIENT_CODE',
  filterValues: [{ value: clientCode }],
});

export const createRegulationIdFilter = (regulationId: string) => ({
  groupKey: 'REGULATION_ID',
  filterValues: [{ value: regulationId }],
});
